import {
  GET_OTP,
  VERIFY_OTP,
  CHANGE_PASSWORD,
  SUCCESS,
  FAIL,
} from "../action_types";

const STATE_INIT = {
  // GET_OTP state
  isOtpLoading: false,
  otpData: null,
  otpError: null,

  // VERIFY_OTP state
  isVerifyingOtp: false,
  verifyOtpData: null,
  verifyOtpError: null,

  // CHANGE_PASSWORD state
  isChangingPassword: false,
  changePasswordData: null,
  changePasswordError: null,
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    // GET_OTP cases
    case GET_OTP:
      return {
        ...state,
        isOtpLoading: true,
        otpData: null,
        otpError: null,
      };
    case `${GET_OTP}_${SUCCESS}`:
      return {
        ...state,
        isOtpLoading: false,
        otpData: payload,
        otpError: null,
      };
    case `${GET_OTP}_${FAIL}`:
      return {
        ...state,
        isOtpLoading: false,
        otpData: null,
        otpError: payload,
      };

    // VERIFY_OTP cases
    case VERIFY_OTP:
      return {
        ...state,
        isVerifyingOtp: true,
        verifyOtpData: null,
        verifyOtpError: null,
      };
    case `${VERIFY_OTP}_${SUCCESS}`:
      return {
        ...state,
        isVerifyingOtp: false,
        verifyOtpData: payload,
        verifyOtpError: null,
      };
    case `${VERIFY_OTP}_${FAIL}`:
      return {
        ...state,
        isVerifyingOtp: false,
        verifyOtpData: null,
        verifyOtpError: payload,
      };

    // CHANGE_PASSWORD cases
    case CHANGE_PASSWORD:
      return {
        ...state,
        isChangingPassword: true,
        changePasswordData: null,
        changePasswordError: null,
      };
    case `${CHANGE_PASSWORD}_${SUCCESS}`:
      return {
        ...state,
        isChangingPassword: false,
        changePasswordData: payload,
        changePasswordError: null,
      };
    case `${CHANGE_PASSWORD}_${FAIL}`:
      return {
        ...state,
        isChangingPassword: false,
        changePasswordData: null,
        changePasswordError: payload,
      };

    // Clear all login state
    case "CLEAR_LOGIN_STATE":
      return STATE_INIT;

    // Clear specific states
    case "CLEAR_OTP_STATE":
      return {
        ...state,
        isOtpLoading: false,
        otpData: null,
        otpError: null,
      };

    case "CLEAR_VERIFY_OTP_STATE":
      return {
        ...state,
        isVerifyingOtp: false,
        verifyOtpData: null,
        verifyOtpError: null,
      };

    case "CLEAR_CHANGE_PASSWORD_STATE":
      return {
        ...state,
        isChangingPassword: false,
        changePasswordData: null,
        changePasswordError: null,
      };

    default:
      return state;
  }
};
